import { render, staticRenderFns } from "./RepairAssessment.vue?vue&type=template&id=582bd222&scoped=true"
import script from "./RepairAssessment.vue?vue&type=script&lang=js"
export * from "./RepairAssessment.vue?vue&type=script&lang=js"
import style0 from "./RepairAssessment.vue?vue&type=style&index=0&id=582bd222&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582bd222",
  null
  
)

export default component.exports